import { useAuth } from './useAuth';

const usePermissions = () => {
  const { permissions } = useAuth();

  const hasPermission = (permission: any, systemRole: any) => {
    const userPermissions = permissions[systemRole] || [];
    return userPermissions.includes(permission);
  };

  return {
    hasPermission
  };
};

export default usePermissions;
